<template>
  <section class="c-form__section">
    <header class="c-form__section-header">
      <h2 class="c-form__section-title" v-if="title">{{ title }}</h2>
      <div class="c-form__section-description" v-html="desc" v-if="desc"></div>
    </header>
    <slot></slot>
  </section>
</template>

<script>
  export default {
    props: {
      desc: {
        type: String,
      },
      title: {
        required: true,
        type: String,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/_contact-us-rap/_vue/FormSection.vue